module.exports = {
  /**
   * GET /account/:accountId/notifications/working_circle
   * Returns pending working circle notifications for the current user:
   *   - reciprocal: someone added them but they haven't added back
   *   - social_overlap: ≥2 circle members share a common colleague
   */
  getWorkingCircleNotifications: {
    settings: ({ accountId }) => ({
      endpoint: `/account/${accountId}/notifications/working_circle`,
      method: 'GET',
    }),
  },

  /**
   * POST /account/:accountId/notifications/working_circle/dismiss
   * Dismisses a working circle notification so it no longer appears.
   * @param {number} connectionId - The connection ID to mark as dismissed.
   */
  dismissCircleNotification: {
    settings: ({ accountId, connectionId }) => ({
      endpoint: `/account/${accountId}/notifications/working_circle/dismiss`,
      body: { connection_id: connectionId },
      method: 'POST',
    }),
  },
}
